import { defineMessages } from 'react-intl';

export default defineMessages({
  offline: {
    id: 'cboard.components.CommunicatorToolbar.SyncButton.offline',
    defaultMessage: 'Offline'
  },
  workingOffline: {
    id: 'cboard.components.CommunicatorToolbar.SyncButton.workingOffline',
    defaultMessage: 'Working Offline'
  },
  savedLocally: {
    id: 'cboard.components.CommunicatorToolbar.SyncButton.savedLocally',
    defaultMessage: 'Saved Locally'
  },
  saving: {
    id: 'cboard.components.CommunicatorToolbar.SyncButton.saving',
    defaultMessage: 'Saving'
  },
  synced: {
    id: 'cboard.components.CommunicatorToolbar.SyncButton.synced',
    defaultMessage: 'Synced'
  }
});
